import React, {useRef, useState, useEffect} from "react"
import {useLocation, useNavigate} from "react-router-dom"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import CondoInfo from "@/components/condos/CondoInfo"
import {inmAndCondIndStyles as styles} from "@/constants"
import {getCondoById} from "@/api/condo"
import Page from "@/layouts/Page"
import {AcapulcoCondoDoc, CondoDoc} from "@casas-diamante/types"
import {CondoSearchState, readPersistedCondoSearchState} from "@/hooks/useCondoBackNavigation"
import {hasCondoPropertiesTableReturnState} from "@/hooks/useCondoPropertiesTableReturn"

function CondoPage() {
   const location = useLocation()
   const navigate = useNavigate()
   const id = location.pathname.split("/condominios/")[1]
   const returnTo = `/condominios/${id}`
   const restorePropertiesTableRef = useRef(hasCondoPropertiesTableReturnState(returnTo))
   const [condo, setCondo] = useState<AcapulcoCondoDoc | CondoDoc>()

   useEffect(() => {
      if (!restorePropertiesTableRef.current) {
         window.scrollTo(0, 0)
      }

      const state = location.state
      const getData = async () => {
         try {
            if (!state || !state.condo) {
               const fetchedCondo = await getCondoById(id)
               setCondo(fetchedCondo)
            } else {
               setCondo(state.condo)
            }
         } catch (error) {
            console.error("Error fetching condo:", error)
         }
      }
      getData()
   }, [id, location.state])

   const handleBack = () => {
      const state = location.state as {
         condo?: CondoDoc | AcapulcoCondoDoc
         fromSearch?: CondoSearchState
      } | null
      const persistedSearch = readPersistedCondoSearchState()

      if (state?.fromSearch?.source === "condos") {
         const restoredSearch =
            persistedSearch?.source === "condos" ? persistedSearch : state.fromSearch

         navigate(restoredSearch.returnTo, {
            state: {
               restoredSearch,
            },
         })
         return
      }

      navigate(-1)
   }

   return (
      <Page className="max-w-[1600px] mx-auto">
         <ArrowBackIcon className="font-bold mb-7 cursor-pointer mt-5" onClick={handleBack} />
         <CondoInfo condId={id} styles={styles} condoData={condo} />
      </Page>
   )
}

export default CondoPage
